import { Menu, Phone } from "lucide-react";

// @ts-ignore //Weird image issues...
import Logo from "../assets/Logo.png";

import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetFooter,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";
import {
  NavigationMenu,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
} from "@/components/ui/navigation-menu";

const PHONE_NUMBER = "07850 458907";
const PHONE_HREF = "tel:07850458907";

const navLinks = [
  { title: "Home", href: "#home" },
  { title: "Services", href: "#services" },
  { title: "Why Us", href: "#why-us" },
  { title: "Our Work", href: "#work" },
  { title: "Reviews", href: "#reviews" },
  { title: "FAQ", href: "#faq" },
  { title: "Contact", href: "#contact" },
];

export function NavBar() {
  return (
    <header className="sticky top-0 z-50 w-full border-b border-white/10 bg-background/95 backdrop-blur supports-backdrop-filter:bg-background/80">
      <div className="mx-auto flex h-18 max-w-360 items-center justify-between gap-4 px-4 md:px-8">
        <a href="#home" className="flex shrink-0 items-center gap-2">
          <img
            src={Logo}
            alt="E.I.M Electrical Contractors"
            className=" max-w-20 rounded p-1.5"
          />
        </a>

        <NavigationMenu className="hidden lg:flex" viewport={false}>
          <NavigationMenuList className="gap-1">
            {navLinks.map((link) => (
              <NavigationMenuItem key={link.href}>
                <NavigationMenuLink
                  href={link.href}
                  className="relative px-3 py-2 text-sm font-medium text-foreground/75 transition-colors hover:bg-transparent hover:text-primary focus:bg-transparent data-[active=true]:bg-transparent after:absolute after:bottom-0 after:left-3 after:right-3 after:h-0.5 after:scale-x-0 after:bg-primary after:transition-transform hover:after:scale-x-100"
                >
                  {link.title}
                </NavigationMenuLink>
              </NavigationMenuItem>
            ))}
          </NavigationMenuList>
        </NavigationMenu>

        <div className="hidden items-center gap-4 lg:flex">
          <a
            href={PHONE_HREF}
            className="flex items-center gap-2 text-sm font-semibold transition-colors hover:text-primary"
          >
            <Phone className="size-4 text-primary" />
            {PHONE_NUMBER}
          </a>
          <Button asChild>
            <a href="#quote">Get a Free Quote</a>
          </Button>
        </div>

        <Sheet>
          <SheetTrigger asChild>
            <Button variant="outline" size="icon" className="lg:hidden">
              <Menu />
              <span className="sr-only">Open menu</span>
            </Button>
          </SheetTrigger>
          <SheetContent side="right" className="w-72">
            <SheetHeader>

            </SheetHeader>
            <nav className="flex flex-col gap-1 px-4">
              {navLinks.map((link) => (
                <SheetClose asChild key={link.href}>
                  <a
                    href={link.href}
                    className="rounded-md px-3 py-2 text-sm font-medium transition-colors hover:bg-accent hover:text-accent-foreground"
                  >
                    {link.title}
                  </a>
                </SheetClose>
              ))}
            </nav>
            <SheetFooter>
              <a
                href={PHONE_HREF}
                className="flex items-center justify-center gap-2 text-sm font-semibold"
              >
                <Phone className="size-4 text-primary" />
                {PHONE_NUMBER}
              </a>
              <SheetClose asChild>
                <Button asChild>
                  <a href="#quote">Get a Free Quote</a>
                </Button>
              </SheetClose>
            </SheetFooter>
          </SheetContent>
        </Sheet>
      </div>
    </header>
  );
}
